/**
 * Shared decorative background used on /o-nas, /uslugi and /kontakt pages.
 * Layered: texture + radial accent glow + gradient fade to page bg.
 *
 * Key fix: in dark mode the texture (noname-opt.webp) appeared against a near-black
 * background at the top, then abruptly transitioned to zinc-900 at h=1100px.
 * Solution: extend the container to cover the full page height and apply
 * a strong early fade that blends the texture into the surface colour smoothly.
 */
export function PageBackground() {
  return (
    <>
      {/* Texture + fade container — fixed height for the decorated header zone */}
      <div className="absolute inset-x-0 top-0 z-0 h-[1100px] pointer-events-none overflow-hidden">
        {/* Texture layer — very low opacity in dark mode to avoid harshness */}
        <img
          src="/media/images/backgrounds/noname-opt.webp"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-[0.7] dark:brightness-[0.2] grayscale rotate-180"
        />

        {/* Radial accent glow — orange for both themes */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 80% 50% at 50% -10%, rgba(249,115,22,0.10) 0%, transparent 70%)",
          }}
        />
        <div
          className="absolute inset-0 hidden dark:block"
          style={{
            background:
              "radial-gradient(ellipse 80% 50% at 50% -10%, rgba(234,88,12,0.06) 0%, transparent 60%)",
          }}
        />

        {/* Fade overlay — starts early in dark mode to hide the texture boundary */}
        {/* Light: fades from transparent to stone-100 */}
        <div
          className="absolute inset-0 block dark:hidden"
          style={{
            background: "linear-gradient(to bottom, transparent 40%, #f5f5f4 100%)",
          }}
        />
        {/* Dark: fades aggressively from zinc-900/0 to zinc-900 to match the page surface */}
        <div
          className="absolute inset-0 hidden dark:block"
          style={{
            background:
              "linear-gradient(to bottom, rgba(24,24,27,0) 0%, rgba(24,24,27,0.6) 50%, rgba(24,24,27,1) 80%)",
          }}
        />
      </div>

      {/* Full-page dark surface fill — ensures the area below the texture container
          is always the correct zinc-900, eliminating any colour mismatch jump */}
      <div className="absolute inset-0 z-[-1] hidden dark:block bg-zinc-900 pointer-events-none" />
    </>
  );
}
